(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    /* JD1 · CP2 / CP-CARD01 V1.6:
     - card-end: mueve quick-add al final del flujo.
     - meta frame fixed: mueve quick-add al root de la card para fijarlo abajo derecha.
     Mismo patrón probado de pf-mega.js: mover nodos con web components
     (se re-conectan solos). Guard de parentElement evita loops del observer. */
  (() => {
    const applyCustomIcon = (content, type, selector) => {
      const template = content.querySelector(`template[data-pf-qa-icon-template="${type}"]`);
      if (!template) return;

      content.querySelectorAll(selector).forEach((icon) => {
        if (icon.querySelector(`.pf-qa-custom-icon[data-pf-qa-custom="${type}"]`)) return;

        const holder = document.createElement('span');
        holder.className = 'pf-qa-custom-icon';
        holder.dataset.pfQaCustom = type;
        holder.appendChild(template.content.cloneNode(true));
        icon.appendChild(holder);
      });
    };

    const relocate = () => {
      document
        .querySelectorAll('.product-card__content.pf-qa-pos-card-end, .product-card__content.pf-qa-card-fixed')
        .forEach((content) => {
          const qa = content.querySelector('.quick-add');
          if (qa && qa.parentElement !== content) content.appendChild(qa);

          applyCustomIcon(content, 'add', '.quick-add__button--add .add-to-cart-icon, .quick-add__button:not(.quick-add__button--choose) .add-to-cart-icon');
          applyCustomIcon(content, 'choose', '.quick-add__button--choose .add-to-cart-icon');
        });
    };

    relocate();
    new MutationObserver(relocate).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', relocate);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pf-newsletter"] && !Shopify.designMode) return;
  try {
    (() => {
    const openModal = () => {
      const modal = document.querySelector('dialog[data-pf-nl-modal]');
      if (modal && !modal.dataset.pfNlShown) {
        modal.dataset.pfNlShown = '1';
        try {
          modal.showModal();
        } catch (e) {
          modal.setAttribute('open', '');
        }
      }
    };

    const copyCode = (btn) => {
      const modal = btn.closest('[data-pf-nl-modal]');
      const code = modal?.querySelector('[data-pf-nl-code]')?.textContent.trim();
      if (!code) return;
      const done = () => {
        btn.textContent = btn.dataset.copiedLabel || 'Copiado';
        btn.dataset.copied = 'true';
        setTimeout(() => {
          btn.textContent = btn.dataset.label || 'Copiar';
          delete btn.dataset.copied;
        }, 2000);
      };
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(() => fallbackCopy(code, done));
      } else {
        fallbackCopy(code, done);
      }
    };

    const fallbackCopy = (text, done) => {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        done();
      } catch (e) {}
      ta.remove();
    };

    document.addEventListener('click', (event) => {
      const copyBtn = event.target.closest('[data-pf-nl-copy]');
      if (copyBtn) return copyCode(copyBtn);

      const closeBtn = event.target.closest('[data-pf-nl-close]');
      if (closeBtn) return closeBtn.closest('dialog')?.close();

      const dlg = event.target.closest('dialog[data-pf-nl-modal]');
      if (dlg && event.target === dlg) dlg.close();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openModal);
    } else {
      openModal();
    }

    document.addEventListener('shopify:section:load', openModal);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pf-retail-title-price"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.JD1RetailTitlePriceV17) return;
    window.JD1RetailTitlePriceV17 = true;

    document.addEventListener('variant:update', (event) => {
      const html = event.detail && event.detail.data && event.detail.data.html;
      if (!html) return;

      document.querySelectorAll('[data-pf-retail-title-price]').forEach((el) => {
        const fresh = html.querySelector(`[data-pf-retail-title-price][data-pf-rtp-id="${el.dataset.pfRtpId}"]`);
        if (fresh) el.innerHTML = fresh.innerHTML;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pf-tabs"] && !Shopify.designMode) return;
  try {
    /* JD1 · pf-tabs: construye la tablist desde los panels (idempotente). */
  (() => {
    const initTabs = (root) => {
      const list = root.querySelector(':scope > .pf-tabs__list');
      const panels = [...root.querySelectorAll(':scope > .pf-tabs__panels > .pf-tab-panel')];
      if (!list || panels.length === 0) return;

      const signature = panels.map((p) => p.dataset.pfTabTitle).join('|');
      if (root.dataset.pfSignature === signature) return;
      root.dataset.pfSignature = signature;

      list.innerHTML = '';
      const activate = (index) => {
        panels.forEach((p, i) => (p.hidden = i !== index));
        [...list.children].forEach((b, i) => {
          b.setAttribute('aria-selected', i === index ? 'true' : 'false');
          b.tabIndex = i === index ? 0 : -1;
        });
      };

      panels.forEach((panel, i) => {
        const id = `pf-tab-${Math.random().toString(36).slice(2, 8)}-${i}`;
        panel.id = `${id}-panel`;
        panel.setAttribute('role', 'tabpanel');

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pf-tabs__tab';
        btn.id = id;
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-controls', panel.id);
        btn.textContent = panel.dataset.pfTabTitle || `Tab ${i + 1}`;
        btn.addEventListener('click', () => activate(i));
        btn.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const next = e.key === 'ArrowRight' ? (i + 1) % panels.length : (i - 1 + panels.length) % panels.length;
          activate(next);
          list.children[next].focus();
        });
        list.appendChild(btn);
      });

      activate(0);
    };

    const initAll = () => document.querySelectorAll('[data-pf-tabs]').forEach(initTabs);

    initAll();
    new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', initAll);

    /* En el editor: seleccionar un pf-tab en el sidebar activa su tab */
    document.addEventListener('shopify:block:select', (e) => {
      const panel = e.target.closest ? e.target.closest('.pf-tab-panel') : null;
      if (!panel) return;
      const root = panel.closest('[data-pf-tabs]');
      if (!root) return;
      const panels = [...root.querySelectorAll(':scope > .pf-tabs__panels > .pf-tab-panel')];
      const idx = panels.indexOf(panel);
      if (idx < 0) return;
      const btn = root.querySelectorAll(':scope > .pf-tabs__list > .pf-tabs__tab')[idx];
      if (btn) btn.click();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pf-title-price"] && !Shopify.designMode) return;
  try {
    /* JD1 · pf-title-price v12.7 — sale current price alignment + stars positioning + card equal title height + vendor/metafield + favoritos */
  (() => {
    /* Variant update: nos reemplazamos con la versión re-renderizada
       (patrón product-price.js) y re-sincronizamos favoritos. */
    document.addEventListener('variant:update', (e) => {
      const html = e.detail && e.detail.data && e.detail.data.html;
      if (!html) return;
      document.querySelectorAll('[data-pf-title-price]').forEach((el) => {
        const fresh = html.querySelector(`[data-pf-title-price][data-pf-tp-id="${el.dataset.pfTpId}"]`);
        if (fresh) el.innerHTML = fresh.innerHTML;
      });
    });

    /* Mobile estilo Amazon: mover el block ANTES de la galería (<750px)
       y devolverlo a su lugar en desktop. Marker invisible = "casa". */
    const mq = window.matchMedia('(max-width: 749px)');

    const place = () => {
      const mobile = mq.matches;

      document.querySelectorAll('[data-pf-title-price][data-pf-mobile-first]').forEach((el) => {
        const id = el.dataset.pfTpId;
        let marker = document.querySelector(`[data-pf-tp-home="${id}"]`);
        if (!marker) {
          marker = document.createElement('span');
          marker.hidden = true;
          marker.setAttribute('data-pf-tp-home', id);
          el.before(marker);
        }

        const section = el.closest('.product-information');
        const grid = section ? section.querySelector('[data-product-grid-content]') : null;

        if (mobile && grid) {
          if (grid.firstElementChild !== el) grid.prepend(el);
        } else if (el.previousElementSibling !== marker) {
          marker.after(el);
        }

        /* Followers: blocks marcados con data-pf-mobile-follow (ej. badges)
           suben justo debajo del block Título + Precio en mobile. */
        if (!section) return;
        let anchor = el;
        section.querySelectorAll('[data-pf-mobile-follow]').forEach((follower) => {
          const fid = follower.dataset.pfFollowId;
          let fMarker = document.querySelector(`[data-pf-tp-home="follow-${fid}"]`);
          if (!fMarker) {
            fMarker = document.createElement('span');
            fMarker.hidden = true;
            fMarker.setAttribute('data-pf-tp-home', `follow-${fid}`);
            follower.before(fMarker);
          }

          if (mobile && grid) {
            if (anchor.nextElementSibling !== follower) anchor.after(follower);
            anchor = follower;
          } else if (follower.previousElementSibling !== fMarker) {
            fMarker.after(follower);
          }
        });
      });
    };

    place();
    mq.addEventListener('change', place);
    document.addEventListener('shopify:section:load', place);
    new MutationObserver(place).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
